import React from "react";

export default function ReviewerReviews({
    reviews = [],
    maxMarks = 0
}) {
    if (!reviews.length) {
        return (
            <div className="mt-3 rounded-xl border border-dashed border-slate-200 bg-slate-50 px-4 py-3">
                <span className="text-xs text-slate-400">
                    No reviewer evaluation available.
                </span>
            </div>
        );
    }

    return (
        <div className="mt-3 rounded-xl border border-slate-200 bg-white overflow-hidden">

            <div className="px-4 py-3 bg-slate-50 border-b border-slate-200">
                <div className="flex items-center justify-between">
                    <div>
                        <h4 className="text-sm font-bold text-slate-700">
                            Reviewer Evaluations
                        </h4>

                        <p className="text-[10px] text-slate-400 mt-0.5">
                            Reviewer marks are read-only for SuperAdmin
                        </p>
                    </div>

                    <span className="text-[10px] font-semibold text-slate-500">
                        {reviews.length} reviewer
                        {reviews.length !== 1 ? "s" : ""}
                    </span>
                </div>
            </div>

            <div className="divide-y divide-slate-100">
                {reviews.map((review) => (
                    <div
                        key={review.reviewerId}
                        className="px-4 py-3 flex items-center justify-between gap-4"
                    >
                        <div className="flex items-center gap-3 min-w-0">

                            <div className="w-8 h-8 shrink-0 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center text-xs font-bold">
                                {review.reviewerName
                                    ?.trim()
                                    ?.charAt(0)
                                    ?.toUpperCase() || "R"}
                            </div>

                            <div className="min-w-0">
                                <div className="text-xs sm:text-sm font-semibold text-slate-700 truncate">
                                    {review.reviewerName}
                                </div>

                                {review.reviewedOn && (
                                    <div className="text-[9px] text-slate-400">
                                        {new Date(
                                            review.reviewedOn
                                        ).toLocaleString()}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="flex items-center gap-2 shrink-0">

                            <span className="px-2 py-1 rounded-full bg-slate-100 text-slate-500 text-[9px] font-semibold">
                                Read only
                            </span>

                            <div className="text-right min-w-[65px]">
                                <div className="text-sm font-bold text-blue-600">
                                    {review.reviewedMarks}
                                    <span className="text-[10px] text-slate-400 font-medium">
                                        {" "}
                                        / {maxMarks}
                                    </span>
                                </div>
                            </div>

                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}